import useRequest from '@/websdk/utils/request';
import { useEffect } from 'react';

export default (function (params) {
  const { isRequestSuccessed, data, exec } = useRequest({
    url: ``,
    name: 'SHUTDOWN_REASON_QUERY_DETAIL',
    method: 'GET',
  });

  useEffect(() => {
    if (params) {
      let url = `/api/shutdown/reason/search/detail`;
      Object.keys(params).forEach((key, index) => {
        if (index === 0) {
          url += '?';
        } else {
          url += '&';
        }
        url += `${key}=${params[key]}`;
      });
      exec(url);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params]);
  //console.error('GETmain==>', JSON.stringify(data));
  return [isRequestSuccessed, data || [], exec];
  // }
});
